import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ClickAwayListener,
  Divider,
  InputAdornment,
  List,
  ListItem,
  Paper,
  Popper,
  TextField,
  Typography,
  Grid,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Fuse from "fuse.js";
import useDebounce from "../../../hooks/useDebounce";

const SearchResults = ({
  anchorEl,
  open,
  onClose,
  onSelect,
  searchResults,
  name,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 10001 }}
      transition
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper style={{ width: 600, height: 600, overflowY: "auto" }}>
          <List dense component="nav" aria-label="main mailbox folders">
            {searchResults?.slice(0, 49)?.map((result, i) => (
              <React.Fragment key={i}>
                <ListItem
                  style={{
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                  button
                  onClick={(e) => {
                    onSelect({
                      target: {
                        name: name,
                        value: result?.item.rolo_ndx,
                      },
                    });
                    onClose(e);
                  }}
                >
                  <Typography variant="subtitle1">
                    {result?.item?.rolo_text}
                  </Typography>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography variant="caption">Last Name</Typography>
                      <Typography variant="body1">
                        {result?.item?.lastname || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption">First Name</Typography>
                      <Typography variant="body1">
                        {result?.item?.firstname || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption">Organization</Typography>
                      <Typography variant="body1">
                        {result?.item?.organization || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption">Email</Typography>
                      <Typography variant="body1">
                        {result?.item?.email_1 || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="caption">Phone</Typography>
                      <Typography variant="body1">
                        {result?.item?.phone_1 || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption">Address</Typography>
                      <Typography variant="body1">
                        {result?.item?.address || "N/A"}
                      </Typography>
                    </Grid>

                    <Grid item xs={2}>
                      <Typography variant="caption">City</Typography>
                      <Typography variant="body1">
                        {result?.item?.city || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="caption">Zip</Typography>
                      <Typography variant="body1">
                        {result?.item?.zipcode || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="caption">State</Typography>
                      <Typography variant="body1">
                        {result?.item?.state || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

const FuzzySearchCurrentRolodex = ({
  onSelect,
  options,
  name,
  placeholder,
}) => {
  const searchRef = useRef(null);

  const [value, setValue] = useState("");
  const debouncedSearchValue = useDebounce(value, 200);
  const [searchResults, setSearchResults] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!!searchResults?.length);
  }, [searchResults]);

  const fuzzySearcher = useMemo(() => {
    if (options.length) {
      return new Fuse(options, {
        ignoreLocation: true,
        keys: [
          "rolo_ndx",
          "lastname",
          "firstname",
          "organization",
          "email_1",
          "phone_1",
          "address",
          "city",
          "zipcode",
          "state",
        ],
      });
    }
  }, [options]);

  const handleClose = (event) => {
    if (searchRef.current && searchRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleChange = (event) => {
    setValue(event?.target?.value);
  };

  useEffect(() => {
    const results = fuzzySearcher && fuzzySearcher.search(debouncedSearchValue);
    setSearchResults(results);
  }, [debouncedSearchValue, fuzzySearcher]);

  return (
    <>
      <TextField
        id="outlined-basic"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        autoComplete="off"
        onChange={handleChange}
        onFocus={() => !!value && setOpen(true)}
        placeholder={placeholder}
        ref={searchRef}
        style={{ width: "100%", minWidth: "226px" }}
        type="search"
        value={value}
        variant="outlined"
        size="small"
      />
      <SearchResults
        anchorEl={searchRef?.current}
        onClose={handleClose}
        onSelect={onSelect}
        open={open}
        searchResults={searchResults}
        name={name}
      />
    </>
  );
};

export default FuzzySearchCurrentRolodex;
